export const mimeTypesWithExtension = {
	"video/mp4": ["mp4"],
	"video/mpeg": ["mpeg"],
	"video/webm": ["webm"],
	"video/x-flv": ["flv"],
	"video/x-m4v": ["m4v"],
	"image/jpeg": ["jpg", "jpeg"],
	"image/png": ["png"],
	"image/apng": ["apng"],
	"image/tiff": ["tiff"],
	"image/gif": ["gif"],
	"image/webp": ["webp"],
	"image/bmp": ["bmp"],
	"image/svg+xml": ["svg"],
	"image/x-icon": ["ico"],
	"image/ico": ["ico"],
	"image/cur": ["cur"],
	"image/heic": ["heic"],
	"image/heif": ["heif"],
	"audio/wav": ["wav"],
	"audio/ogg": ["ogg"],
	"audio/opus": ["opus"],
	"audio/mp4": ["mp4"],
	"audio/mpeg": ["mp3"],
	"audio/aac": ["aac"],
	"text/plain": ["txt"],
	"text/html": ["html"],
	"text/css": ["css"],
	"text/csv": ["csv"],
	"text/x-sql": ["sql"],
	"application/xml": ["xml"],
	"application/sql": ["sql"],
	"application/x-sql": ["sql"],
	"application/x-sqlite3": ["sqlite3"],
	"application/x-pkcs12": ["pfx"],
	"application/pdf": ["pdf"],
	"application/json": ["json"],
	"application/javascript": ["js"],
};

export const mimeTypes = Object.keys(mimeTypesWithExtension) as [
	MimeType,
	...MimeType[],
];

export type MimeType = keyof typeof mimeTypesWithExtension;
